import { MaintenanceWindowPreviewPatchManagementBaseDataProvider } from './MaintenanceWindowPreviewPatchManagementBaseDataProvider';
import { MaintenanceWindowPreviewPatchManagementWebComponentSchema } from '../types';

export class MaintenanceWindowPreviewPatchManagementGzDataProvider extends MaintenanceWindowPreviewPatchManagementBaseDataProvider {
  async getDataForView(
    maintenanceWindowId: string
  ): Promise<MaintenanceWindowPreviewPatchManagementWebComponentSchema> {
    const response = await this.dependencies.api.clients.MaintenanceWindows.getMaintenanceWindowById(
      maintenanceWindowId
    );

    if (!response.data) {
      throw new Error('Field data not set in getMaintenanceWindowById reponse');
    }

    return response.data;
  }
}
